import { render, staticRenderFns } from "./SliderImages.vue?vue&type=template&id=477458c1"
import script from "./SliderImages.vue?vue&type=script&lang=js"
export * from "./SliderImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports